export default __webpack_public_path__ + "media/images/ui-icons_ffffff_256x240-2e2a588883eebc04ad50854a6ecfbac1.png";